import React, { useState, useEffect } from 'react';
import WirelessAccessPoints from "../WirelessAccessPoints";

const Modal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    const handleClickOutside = (event) => {
      if (event.target.classList.contains('modal-overlay')) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscapeKey);
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-4xl w-full"
        style={{
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          maxWidth: '56rem',
          width: '100%',
          maxHeight: '90vh',
          marginTop: "3%"
        }}
      >
        <div className="flex justify-end items-center p-4 border-b" style={{
          marginLeft: window.innerWidth < 768 ? "80%" : "90%"
        }}>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-90 ml-auto"
          >
            ✕
          </button>
        </div>
        <div
          className="p-4 overflow-y-auto"
          style={{
            maxHeight: 'calc(90vh - 100px)',
            overflowY: 'auto'
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

const WirelessAccessPointsLink = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <li>
        <p className="mb-0">
          <strong>Canais Suportados: </strong>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleOpenModal();
            }}
            style={{
              color: '#1155CC',
              textDecoration: 'underline',
              fontWeight: 'bold',
            }}
            onMouseEnter={(e) => e.target.style.color = '#0056b3'}
            onMouseLeave={(e) => e.target.style.color = '#007bff'}
          >
            Clique aqui
          </a>

        </p>
      </li>

      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <WirelessAccessPoints />
      </Modal>
    </>
  );
};

export default WirelessAccessPointsLink;